<template>
  <v-flex
    class="xs12 sm6 pa-3"
    :class="{
      'pr-4': $vuetify.breakpoint.smAndUp,
      'custom_add_border-bottom': $vuetify.breakpoint.xsOnly
    }"
  >
    <div v-if="$vuetify.breakpoint.smAndUp">
      <PaymentDetailTitle :paycomplete="paycomplete"></PaymentDetailTitle>
      <PaymentDetailBody :splited="splited"></PaymentDetailBody>
    </div>

    <v-expansion-panel
      v-if="$vuetify.breakpoint.xsOnly"
      v-model="expand"
      expand
      style="box-shadow:none"
    >
      <v-expansion-panel-content key="1" style="padding:0">
        <template v-slot:actions>
          &nbsp;
          <span v-if="!expand[0]" style="color:#278BED">
            {{ text.show }}
          </span>
          <span v-if="expand[0]" style="color:#278BED">
            {{ text.hide }}
          </span>
        </template>
        <template v-slot:header>
          <PaymentDetailTitle :paycomplete="paycomplete"></PaymentDetailTitle>
        </template>
        <PaymentDetailBody :splited="splited"></PaymentDetailBody>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-layout pb-3>
      <!--      <v-flex-->
      <!--        v-if="!splited"-->
      <!--        xs6-->
      <!--        class="body-1 font-weight-bold"-->
      <!--        style="color:#373A3C"-->
      <!--      >-->
      <!--        {{ text.total }}-->
      <!--      </v-flex>-->
      <v-flex
        xs6
        class="body-1 font-weight-bold red--text"
        style="color:#373A3C"
      >
        {{ text.outstanding }}
      </v-flex>
      <v-flex
        xs6
        class="subheading font-weight-bold red--text"
        style="color:#0270BA"
        text-xs-right
      >
        {{ outstanding | currency }}
      </v-flex>
    </v-layout>
    <v-layout v-if="parseFloat(outstanding) > 0" pb-3>
      <div class="red--text">{{ text.attention }}</div>
    </v-layout>
    <v-flex v-for="(file, index) in files" :key="index" pb-3 class="caption">
      <img src="../assets/document.svg" />
      &nbsp; {{ file.fileName }} -
      <a :href="s3 + file.filePath" target="_blank">
        {{ text.download }}
      </a>
    </v-flex>

    <v-flex v-if="!paycomplete" class="caption">
      <v-icon small color="red">info</v-icon>
      <span style="color: red">
        &nbsp; {{ text.expireDate }} {{ expireDateTime }}
      </span>
    </v-flex>

    <div v-if="billPayment.length > 0">
      <v-flex mt-4 pb-3 class="body-1 font-weight-bold" style="color:#373A3C">
        {{ text.paymentDetail }}
      </v-flex>
      <v-layout
        v-for="bp in billPayment"
        :key="bp.id"
        class="caption pb-1"
        style="color:#373A3C"
      >
        <v-flex xs6>{{ bp.paymentdetail }}</v-flex>
        <v-flex xs6 text-xs-right>{{ bp.paid | currency }}</v-flex>
      </v-layout>
    </div>
  </v-flex>
</template>

<script>
export default {
  data() {
    return {
      expand: [],
      s3: process.env.VUE_APP_S3
      //s3: this.$store.state.s3
    }
  },
  computed: {
    billPayment() {
      return this.$store.state.billPayment ? this.$store.state.billPayment : []
    },
    files() {
      if (!this.$store.state.files) return []
      return this.$store.state.files
    },
    outstanding() {
      return this.$options.filters.currency(this.$store.state.outstanding)
    },
    splited() {
      return this.$store.getters.splited
    },
    expireDateTime() {
      if (this.$store.state.language == 'EN') {
        return this.$store.state.expireDateTimeEn
      } else {
        return this.$store.state.expireDateTimeTh
      }
    },
    paycomplete() {
      return this.$store.state.paycomplete
    },
    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          show: 'show',
          hide: 'hide',
          attachDocument: 'Attached Document',
          download: 'Download',
          total: 'Total',
          outstanding: 'Outstanding balance',
          expireDate: 'Please pay in full before ',
          paymentDetail: 'Payment Detail',
          attention: 'Please specific payment type to complete this payment'
        }
      } else {
        obj = {
          show: 'แสดง',
          hide: 'ปิด',
          attachDocument: 'เอกสารแนบ',
          download: 'ดาวน์โหลด',
          total: 'ยอดรวม',
          outstanding: 'ชำระเพิ่ม',
          expireDate: 'กรุณาชำระเงินให้ครบภายใน วันที่',
          paymentDetail: 'ข้อมูลการชำระ',
          attention:
            'กรุณาเลือกวิธีการชำระเงิน เพื่อดำเนินการชำระเงินให้สมบูรณ์'
        }
      }
      return obj
    }
  },
  methods: {
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    }
  }
}
</script>

<style>
.custom_add_border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 16px;
}
</style>
